import NextLink from "next/link";

import { LazyLoopVideo } from "@/components/homepage/lazy-loop-video";
import { Button } from "@/components/ui/button";

/**
 * "O que é a Lista de Casamento Tania Bulhões?" — defines the product in brand
 * language, ahead of any signup CTA (Tech Spec § US-02).
 */
export function WhatIsSection() {
  return (
    <section id="o-que-e" className="bg-[var(--tb-white)] py-[clamp(70px,10vh,140px)]">
      <div className="mx-auto flex max-w-[900px] flex-col items-center gap-[clamp(20px,2.6vw,32px)] px-[clamp(20px,5vw,40px)] text-center">
        <span className="text-[15px] font-medium uppercase tracking-[0.16em] text-tb-green">
          O que é a Lista de Casamento Tania Bulhões?
        </span>

        {/* No max-width: the reference lets the heading fill the 900px column. */}
        <h2 className="tb-reveal-view font-display text-[clamp(28px,3.7vw,51px)] font-light uppercase leading-[var(--tb-typography-line-height-display)] tracking-[-0.01em] [text-wrap:balance]">
          Fácil e <span className="text-tb-green">exclusiva</span>, a melhor solução para o seu momento.
        </h2>

        <p className="mx-auto max-w-[620px] text-[clamp(15px,1.1vw,17px)] leading-[1.7] text-[var(--fg-muted)] [text-wrap:pretty]">
          Queremos estar presentes nas suas memórias mais importantes. Ao criar sua lista conosco, você conta com atendimento dedicado do início ao fim e uma seleção de peças autorais para vestir a sua nova casa.
        </p>

        {/* The canon's solid button (ATM-04): 12px, 700, in pure white (the DS ships 13px/500
            in porcelain). Overridden per-instance rather than forking the DS variant. */}
        <Button asChild size="lg" className="gap-3 px-[30px] text-[12px] font-bold text-[var(--tb-white)] duration-[400ms]">
          <NextLink href="/onboarding">Criar minha lista</NextLink>
        </Button>
      </div>

      {/*
        Decorative brand film: "Hero Mesa de Chá Wide", the one the person sent on 2026-10-05
        (`docs/internal/Hero Mesa de Chá Wide - Novos vídeos - LC.zip`), encoded for the web —
        H.264 with no audio track and the index up front, 5.7MB against the 46MB master. Muted,
        looping and uncontrolled, so it carries no essential content (Tech Spec § Acessibilidade).
        The `poster` is required — without it the block paints as an empty rectangle until the
        first frame decodes — and is the film's own first frame (AVIF, made from the JPG), so
        nothing changes when it starts. The film is not downloaded until it is on screen
        (`LazyLoopVideo`, PERF-03). A smaller cut for phones needs a new asset from the designer.
        Aspect ratios mirror IMAGE_ASPECT_RATIOS.videoMobile / .videoDesktop; they are inlined
        because Tailwind only extracts literals.
      */}
      <div className="mx-auto mt-[clamp(48px,7vh,96px)] max-w-[1600px] px-[clamp(20px,4vw,56px)]">
        <div className="relative aspect-[3/2] overflow-hidden bg-[var(--tb-porcelain-deep,#ECE2D8)] [@media(min-width:900px)]:aspect-[16/7]">
          <LazyLoopVideo
            src="/videos/homepage/mesa-de-cha.mp4"
            poster="/images/homepage/mesa-de-cha-poster.avif"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
